import React from 'react'
import './ConfirmModal.scss'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react-pro'

export default function AdmitPatientEventEditConfirm({ visible, onClose, onConfirm }) {
  return (
    <CModal
      className="confirm-modal"
      visible={visible}
      onClose={onClose}
      fullscreen="lg"
      alignment={'center'}
    >
      <CModalHeader className="d-flex">Are you sure?</CModalHeader>
      <CModalBody>
        <div style={{ textAlign: 'center' }}>
          You have already selected an admission date for this encounter. Changing the date may
          affect any encounters that exist after the chosen date.
        </div>
      </CModalBody>
      <CModalFooter>
        <CButton color="secondary" onClick={onClose}>
          Cancel
        </CButton>
        <CButton color="primary" onClick={onConfirm}>
          Confirm
        </CButton>
      </CModalFooter>
    </CModal>
  )
}
